import { Button } from "components/ui/button";
import { Badge } from "components/ui/badge";
import { format } from "date-fns";
import { MoreVerticalIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import DropdownMenuComponent from "../components/action-table";
import SortedCell from "../components/sorted-cell";
import { IRegional } from "src/@types/regional";
import { StatusEnum } from "@/enum/status";

const muthedRow = (status: StatusEnum) => {
  return cn("w-full h-full px-[10px] py-[6px]", {
    "bg-[#F0F0F1]": status === StatusEnum.INACTIVE,
  });
};

export const columns = (
  onOpenDeactivateDialog: (row: IRegional) => void
) => [
  {
    accessorKey: "name",
    header: () => <div> Nome </div>,
    cell: ({ row }: { row: any }) => {
      return (
        <div className={`flex justify-start ${muthedRow(row?.original?.status)}`}>
          {row.original.name}
        </div>
      );
    },
    className: "!p-0",
  },

  {
    accessorKey: "email",
    header: () => <div> E-mail </div>,
    cell: ({ row }: { row: any }) => {
      return (
        <div className={`flex justify-start ${muthedRow(row?.original?.status)}`}>
          {row?.original?.email}
        </div>
      );
    },
    className: "!p-0",
  },

  {
    accessorKey: "status",
    header: () => <div> Status </div>,
    cell: ({ row }: { row: any }) => {
      const status = row.original.status;
      return (
        <div className={`flex justify-start ${muthedRow(status)}`}>
          <Badge
            variant={status ? "default" : "secondary"}
            className={cn({
              "bg-green-500 hover:bg-green-600 text-white": status === StatusEnum.ACTIVE,
              "bg-gray-400 hover:bg-gray-500 text-white": status === StatusEnum.INACTIVE,
            })}
          >
            {status === StatusEnum.ACTIVE ? "Ativo" : "Inativo"}
          </Badge>
        </div>
      );
    },
    className: "!p-0",
  },

  {
    accessorKey: "created_at",
    header: ({ column }: { column: any }) => (
      <SortedCell key={"created_at"} column={column} title={"Criado em"} />
    ),
    cell: ({ row }: { row: any }) => {
      const createdAt = row.original.created_at;
      const formattedDate = format(new Date(createdAt), "dd/MM/yyyy");
      return (
        <div className={`flex justify-start ${muthedRow(row?.original?.status)}`}>
          {formattedDate}
        </div>
      );
    },
    className: "!p-0",
  },

  {
    id: "actions",
    header: () => <div> Ações </div>,
    cell: ({ row }: { row: any }) => {
      return (
        <div
          className={`w-full flex items-center justify-center ${muthedRow(
            row?.original?.status
          )}`}
        >
          <DropdownMenuComponent
            row={row?.original}
            trigger={
              <Button
                variant="link"
                className="p-0 m-0 h-[0px] flex items-center justify-center"
              >
                <MoreVerticalIcon className="w-[20px]" />
              </Button>
            }
            onOpenDeactivateDialog={onOpenDeactivateDialog}
          />
        </div>
      );
    },
    className: "!p-0 w-[50px] items-center justify-center",
  },
];
